import { cn } from "@/lib/utils";
import { ButtonHTMLAttributes, ClassAttributes, ElementType } from "react";

type TabProps = ClassAttributes<HTMLButtonElement> &
    ButtonHTMLAttributes<HTMLButtonElement> & {
        className?: string;
        variant: "filled" | "line";
        interaction?: "hover" | "select";
        active?: boolean;
        as?: ElementType;
    };

export const Tab = ({
    variant,
    interaction,
    active,
    children,
    className,
    as: Component = "button",
    ...props
}: TabProps) => {
    const baseClasses =
        "relative py-1.5 px-3 text-[14px] cursor-pointer flex items-center justify-center";

    const variantClasses = {
        filled: cn(
            "rounded-medium bg-grey-a100 text-text-placeholder",
            "hover:bg-grey-a100 hover:text-text-primary",
            "[&[data-interaction=select]]:bg-secondary-main [&[data-interaction=select]]:text-common-white-main dark:[&[data-interaction=select]]:text-common-black-main"
        ),
        line: cn(
            "rounded-none border-b border-line bg-background text-text-placeholder",
            "hover:bg-background hover:text-text-placeholder",
            "[&[data-interaction=select]]:border-secondary-main [&[data-interaction=select]]:bg-background [&[data-interaction=select]]:text-text-primary",
            "after:absolute after:bottom-0 after:left-0 after:h-[1.5px] after:w-full after:shadow-[inset_0px_-1.5px_0px_var(--line)] after:content-['']",
            "[&[data-interaction=select]]:after:shadow-[inset_0px_-1.5px_0px_currentColor]"
        )
    }[variant];

    return (
        <Component
            className={cn(baseClasses, variantClasses, className)}
            data-interaction={active ? "select" : interaction}
            {...props}
        >
            {children}
        </Component>
    );
};
